// removed by extract-text-webpack-plugin
module.exports = {"intro-page-wrapper":"introTutorial-module-intro-page-wrapper-29a28c3dac97b8d64198419c72b5c43f--","title":"introTutorial-module-title-a8b24584a1c9b87e3adb31143e45dc9b--","intro-text":"introTutorial-module-intro-text-ab977f1dec79b381bd2213f387da2913--","start-sim-button":"introTutorial-module-start-sim-button-3c8f0a253d75239e96e3bc62543bdab6--","button-text":"introTutorial-module-button-text-b6b0a1767b29a9f80625ba29fdb3e52a--"};


//////////////////
// WEBPACK FOOTER
// /src/components/intro/pages/tutorial/introTutorial.module.scss
// module id = 2237
// module chunks = 0